import Brand from "../../Assets/images/logo-new.svg";

const Logo = () => {
	return (
		<>
			<img src={Brand} alt="Natureland" />
		</>
	);
};

export default Logo;
